export const eventsConstants = {
  // Events
  FETCH_EVENTS_REQUEST: 'FETCH_EVENTS_REQUEST',
  FETCH_EVENTS_SUCCESS: 'FETCH_EVENTS_SUCCESS',
  FETCH_EVENTS_FAILURE: 'FETCH_EVENTS_FAILURE',

  FETCH_EVENT_REQUEST: 'FETCH_EVENT_REQUEST',
  FETCH_EVENT_SUCCESS: 'FETCH_EVENT_SUCCESS',
  FETCH_EVENT_FAILURE: 'FETCH_EVENT_FAILURE',

  FETCH_EVENT_PUBLIC_REQUEST: 'FETCH_EVENT_PUBLIC_REQUEST',
  FETCH_EVENT_PUBLIC_SUCCESS: 'FETCH_EVENT_PUBLIC_SUCCESS',
  FETCH_EVENT_PUBLIC_FAILURE: 'FETCH_EVENT_PUBLIC_FAILURE',

  CREATE_EVENT_REQUEST: 'CREATE_EVENT_REQUEST',
  CREATE_EVENT_SUCCESS: 'CREATE_EVENT_SUCCESS',
  CREATE_EVENT_FAILURE: 'CREATE_EVENT_FAILURE',

  UPDATE_EVENT_REQUEST: 'UPDATE_EVENT_REQUEST',
  UPDATE_EVENT_SUCCESS: 'UPDATE_EVENT_SUCCESS',
  UPDATE_EVENT_FAILURE: 'UPDATE_EVENT_FAILURE',

  DELETE_EVENT_REQUEST: 'DELETE_EVENT_REQUEST',
  DELETE_EVENT_SUCCESS: 'DELETE_EVENT_SUCCESS',
  DELETE_EVENT_FAILURE: 'DELETE_EVENT_FAILURE',

  // Event Registrations
  FETCH_EVENT_REGISTRATIONS_REQUEST: 'FETCH_EVENT_REGISTRATIONS_REQUEST',
  FETCH_EVENT_REGISTRATIONS_SUCCESS: 'FETCH_EVENT_REGISTRATIONS_SUCCESS',
  FETCH_EVENT_REGISTRATIONS_FAILURE: 'FETCH_EVENT_REGISTRATIONS_FAILURE',

  CREATE_EVENT_REGISTRATION_REQUEST: 'CREATE_EVENT_REGISTRATION_REQUEST',
  CREATE_EVENT_REGISTRATION_SUCCESS: 'CREATE_EVENT_REGISTRATION_SUCCESS',
  CREATE_EVENT_REGISTRATION_FAILURE: 'CREATE_EVENT_REGISTRATION_FAILURE',

  UPDATE_EVENT_REGISTRATION_REQUEST: 'UPDATE_EVENT_REGISTRATION_REQUEST',
  UPDATE_EVENT_REGISTRATION_SUCCESS: 'UPDATE_EVENT_REGISTRATION_SUCCESS',
  UPDATE_EVENT_REGISTRATION_FAILURE: 'UPDATE_EVENT_REGISTRATION_FAILURE',

  DELETE_EVENT_REGISTRATION_REQUEST: 'DELETE_EVENT_REGISTRATION_REQUEST',
  DELETE_EVENT_REGISTRATION_SUCCESS: 'DELETE_EVENT_REGISTRATION_SUCCESS',
  DELETE_EVENT_REGISTRATION_FAILURE: 'DELETE_EVENT_REGISTRATION_FAILURE',

  // WhatsApp Notifications
  FETCH_WHATSAPP_CONFIGS_REQUEST: 'FETCH_WHATSAPP_CONFIGS_REQUEST',
  FETCH_WHATSAPP_CONFIGS_SUCCESS: 'FETCH_WHATSAPP_CONFIGS_SUCCESS',
  FETCH_WHATSAPP_CONFIGS_FAILURE: 'FETCH_WHATSAPP_CONFIGS_FAILURE',

  CREATE_WHATSAPP_CONFIG_REQUEST: 'CREATE_WHATSAPP_CONFIG_REQUEST',
  CREATE_WHATSAPP_CONFIG_SUCCESS: 'CREATE_WHATSAPP_CONFIG_SUCCESS',
  CREATE_WHATSAPP_CONFIG_FAILURE: 'CREATE_WHATSAPP_CONFIG_FAILURE',

  UPDATE_WHATSAPP_CONFIG_REQUEST: 'UPDATE_WHATSAPP_CONFIG_REQUEST',
  UPDATE_WHATSAPP_CONFIG_SUCCESS: 'UPDATE_WHATSAPP_CONFIG_SUCCESS',
  UPDATE_WHATSAPP_CONFIG_FAILURE: 'UPDATE_WHATSAPP_CONFIG_FAILURE',

  DELETE_WHATSAPP_CONFIG_REQUEST: 'DELETE_WHATSAPP_CONFIG_REQUEST',
  DELETE_WHATSAPP_CONFIG_SUCCESS: 'DELETE_WHATSAPP_CONFIG_SUCCESS',
  DELETE_WHATSAPP_CONFIG_FAILURE: 'DELETE_WHATSAPP_CONFIG_FAILURE',

  SEND_WHATSAPP_NOTIFICATION_REQUEST: 'SEND_WHATSAPP_NOTIFICATION_REQUEST',
  SEND_WHATSAPP_NOTIFICATION_SUCCESS: 'SEND_WHATSAPP_NOTIFICATION_SUCCESS',
  SEND_WHATSAPP_NOTIFICATION_FAILURE: 'SEND_WHATSAPP_NOTIFICATION_FAILURE',
};

export default eventsConstants;
